import { render, staticRenderFns } from "./QuantityTypeSelector.vue?vue&type=template&id=afcf1092&"
import script from "./QuantityTypeSelector.vue?vue&type=script&lang=ts&"
export * from "./QuantityTypeSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
